import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }} className={className} {...rest}>
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => <p className={`eyebrow ${className}`}>{children}</p>;

export const PageHeader = ({ eyebrow, title, sub, testid }) => (
  <section data-testid={testid} className="pt-36 sm:pt-44 pb-12 sm:pb-16">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-6 items-end">
      <div className="lg:col-span-8 overflow-hidden">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="eyebrow text-[#FF5A5F] mb-4">{eyebrow}</motion.p>
        <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.92]">
          {title.map((t, i) => (
            <span key={t} className="block overflow-hidden pb-2">
              <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, delay: 0.1 + i * 0.12, ease: EASE }}>{t}</motion.span>
            </span>
          ))}
        </h1>
      </div>
      {sub && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45, duration: 0.8 }}
          className="lg:col-span-4 text-base sm:text-lg text-[#4A4560] leading-relaxed">{sub}</motion.p>
      )}
    </div>
  </section>
);
